import { Button } from 'primereact/button';
import { EditText } from '../../component/ui/edit-text/edit-text';
import { Password } from 'primereact/password';
import { useState } from 'react';
import { logInOperation } from './operations/log-in-operation';
import { useNavigate } from 'react-router-dom';
import HarediLogo from '../../assets/logos/haredi-logo.png';

import './login-page.css';

export const LoginPage = () => {
  const [mail, setMail] = useState<string | undefined>();
  const [password, setPassword] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleOperation = async () => {
    await logInOperation(mail, password, navigate, setLoading);
  };

  return (
    <div className="login-page-root">
      <div className="login-page-brand">
        <div className="login-page-brand-content">
          <div className="login-page-logo-wrap">
            <img
              src={HarediLogo}
              alt="המרכז החרדי להכשרה מקצועית"
              className="login-page-logo"
            />
          </div>
          <h1 className="login-page-brand-title">המרכז החרדי להכשרה מקצועית</h1>
          <p className="login-page-brand-subtitle">
            מערכת ניהול אקדמית מתקדמת לניהול לימודים, סטודנטים, כספים ודוחות —
            במקום אחד.
          </p>
          <div className="login-page-features">
            <div className="login-page-feature">
              <i className="pi pi-graduation-cap" />
              <span>ניהול תוכניות לימודים וקורסים</span>
            </div>
            <div className="login-page-feature">
              <i className="pi pi-chart-line" />
              <span>דוחות ותובנות בזמן אמת</span>
            </div>
            <div className="login-page-feature">
              <i className="pi pi-shield" />
              <span>גישה למשתמשים מורשים בלבד</span>
            </div>
          </div>
        </div>
      </div>

      <div className="login-page-form-panel">
        <div className="login-page-form-card p-fluid">
          <div className="login-page-form-header">
            <h2 className="login-page-form-title">התחברות</h2>
            <p className="login-page-form-subtitle">הזן את פרטי ההתחברות שלך</p>
          </div>

          <EditText height={'36px'} title={'מייל'} onChange={setMail} />

          <div className="login-page-password-field">
            <label className="login-page-password-label">סיסמא</label>
            <Password
              onChange={(e) => setPassword(e.target.value)}
              toggleMask
              feedback={false}
              style={{ width: '100%' }}
              inputStyle={{ height: '36px', width: '100%' }}
              inputClassName="login-page-password-input"
              className="login-page-password"
            />
          </div>

          <div className="login-page-warning">
            <i className="pi pi-exclamation-triangle" />
            <span>
              לתשומת לבך: מומלץ לא לשמור את הסיסמה במחשב זה, במיוחד אם הוא לא
              פרטי ומאובטח.
            </span>
          </div>

          <Button
            loading={loading}
            className="login-page-submit"
            label="התחברות"
            onClick={handleOperation}
          />
        </div>
      </div>
    </div>
  );
};
